<template>
  <div>
    <div class="d-flex flex-column align-items-end">
      <div>
        <el-tooltip content="Chỉnh sửa" placement="top" :open-delay="500">
          <a target="_blank" @click="enablePopup">
            <FAIcon
              icon="fas fa-pen-nib icon"
              :class="{ 'disabled-icon': isDeleted }"
            />
          </a>
        </el-tooltip>
      </div>
    </div>
    <el-dialog :visible.sync="isShowEditDocumentForm" width="50%">
      <div class="title_popup text-center">
        <FAIcon icon="far fa-pen-nib" /> Sửa thông tin tài liệu
      </div>
      <el-form
        ref="formPlagiarism"
        label-width="160px"
        label-position="right"
        @submit.native.prevent
      >
        <el-form-item label="Tiêu đề">
          <el-input placeholder="Tiêu đề tài liệu" v-model="title"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDocumentForm = false"
          ><FAIcon icon="fas fa-times" /> Hủy bỏ</el-button
        >
        <el-button type="primary" @click="onSubmitEditDocumentForm"
          ><i class="fas fa-upload"></i> Cập nhập tài liệu</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiUpdateGroupDocument } from "@/services/document_management_service"
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: "DocumentEdit",
  props: ["info", "isDeleted"],
  components: {FAIcon},
  data: function () {
    return {
      isShowEditDocumentForm: false,
      fileList: [],
      title: "",
      id: null,
    }
  },
  updated() {
    if (this.id === this.info.id) return
    this.id = this.info.id
    this.title = this.info.title
  },
  methods: {
    enablePopup() {
      if (!this.isDeleted) {
        this.isShowEditDocumentForm = true
      }
    },
    async onSubmitEditDocumentForm() {
      apiUpdateGroupDocument(this.info.slug, this.title)
        .then(() => {
          this.$message({
            message: "Chỉnh sửa thành công",
            type: "success",
          })
          this.isShowEditDocumentForm = false
          this.$emit("success")
        })
        .catch(() => {
          this.$message({
            message: "Có lỗi xảy ra",
            type: "error",
          })
        })
    },
  },
}
</script>

<style scoped>
.checker-type-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.checker-type {
  width: 180px;
  margin-right: 10px;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

label.el-form-item__label {
  font-size: 18px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.icon {
  color: darkorange;
  cursor: pointer;
}

.icon .disabled-icon {
  color: gray;
  opacity: 0.5;
  cursor: default;
}
</style>
